import Cookies from "js-cookie"

const state = {
  sidebar: {
    opened: !!(Cookies.get("sidebarStatus") && Cookies.get("sidebarStatus") == 1),
    withoutAnimation: false,
    fakeClick: false // 做收缩时，点击记录使用
  },
  device: "desktop",
  nowRouteInfo: { path: "/" }
}

const mutations = {
  TOGGLE_SIDEBAR: state => {
    state.sidebar.opened = !state.sidebar.opened
    state.sidebar.withoutAnimation = false
    if (state.sidebar.opened) {
      Cookies.set("sidebarStatus", 1)
    } else {
      Cookies.set("sidebarStatus", 0)
      state.sidebar.fakeClick = false
    }
  },
  CLOSE_SIDEBAR: (state, withoutAnimation) => {
    Cookies.set("sidebarStatus", 0)
    state.sidebar.opened = false
    state.sidebar.withoutAnimation = withoutAnimation
    state.sidebar.fakeClick = false
  },
  TOGGLE_DEVICE: (state, device) => {
    state.device = device
  },
  SAVE_nowRouteInfo: (state, route) => {
    state.nowRouteInfo = route
  },
  SAVE_FAKECLICK: state => {
    state.sidebar.fakeClick = true
  }
}

const actions = {
  toggleSideBar({ commit }) {
    commit("TOGGLE_SIDEBAR")
  },
  closeSideBar({ commit }, { withoutAnimation }) {
    commit("CLOSE_SIDEBAR", withoutAnimation)
  },
  toggleDevice({ commit }, device) {
    commit("TOGGLE_DEVICE", device)
  },
  saveNowRouteInfo({ commit }, nowRouteInfo) {
    commit("SAVE_nowRouteInfo", nowRouteInfo)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
